import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgMaterialer({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M20.443 3.525c.542 0 .989.41 1.05.936l.007.124v17.233a2.18 2.18 0 0 1-2.015 2.176l-.163.006H7.076a1.058 1.058 0 0 1-.123-2.112l.123-.007h11.22a1.09 1.09 0 0 0 1.082-.964l.007-.127V4.585c0-.586.474-1.06 1.058-1.06ZM16.893 0a1.09 1.09 0 0 1 1.081.964l.008.127v18.293c0 .56-.42 1.02-.962 1.084l-.127.007H3.589a1.09 1.09 0 0 1-1.082-.964l-.007-.127V4.389h3.292a1.09 1.09 0 0 0 1.082-.964l.007-.127V0h10.012Zm-2.504 12.18H6.093a.702.702 0 0 0-.104 1.399l.104.007h8.296a.702.702 0 0 0 0-1.406Zm0-2.988H6.093a.702.702 0 0 0-.104 1.399l.104.008h8.296a.702.702 0 0 0 0-1.407Zm0-2.987H6.093a.702.702 0 0 0-.104 1.398l.104.008h8.296a.702.702 0 0 0 0-1.406ZM5.477.005v1.887c0 .56-.42 1.02-.962 1.084l-.127.007H2.505L5.477.005Z"
                    fill="#297A71"
                    fillRule="nonzero"
                />
            </g>
        </svg>
    )
}
SvgMaterialer.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgMaterialer
